import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../../../shared/components/skeleton/skeleton-block';

/**
 * Nearest drop-off card skeleton. Independent of the delivery rate-call region.
 * Reserves the real card geometry so the layout does not jump when locator returns.
 */
@Component({
  selector: 'app-nearest-drop-off-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './nearest-drop-off-skeleton.html',
  styleUrl: './nearest-drop-off-skeleton.scss',
})
export class NearestDropOffSkeleton {}
